import T from '@wojtekmaj/react-t';

export default function LoadingText() {
  return (
    <p>
      <T>Loading…</T>
    </p>
  );
}
